<app-main-dialog (dismiss)="dismiss()">
  <div modalTitle>
    @if (step() === 1) {
      {{ 'contract.new' | translate }}
    } @else if (step() === 2) {
      {{ 'contract.createWithAi' | translate }}
    } @else if (step() === 3) {
      {{ 'contract.step3' | translate }}
    }
  </div>
  <app-split-page>
    @if (step() === 1) {
      <div class="main-container">
        <h4>{{ 'contract.createWithAi' | translate }}</h4>
        <p> {{ 'contract.createWithAiInfo' | translate }}</p>
        <ion-item button="true"
          lines="none"
          (click)="step.set(2)">
          <ion-icon slot="start"
            name="color-wand-outline"></ion-icon>
          {{ 'contract.createWithAi' | translate }}
        </ion-item>
      </div>
    } @else if (step() === 2) {
      <h4>{{ 'contract.createWithAi' | translate }}</h4>
      <p>{{ 'contract.aiInfo' | translate }}</p>
      <ion-item class="description"
        lines="none">
        <ion-textarea autocapitalize="on"
          class="description"
          [(ngModel)]="prompt"
          rows="5"
          [placeholder]="'projects.tellAboutContract' | translate">
        </ion-textarea>
        <app-speech-to-text (text)="onMic($event)"></app-speech-to-text>
      </ion-item>
      <h4>{{ 'projects.aiLoad' | translate }}</h4>
      <p>{{ 'contract.aiLoadInfo' | translate }}</p>
      @for (document of contractUrls(); track $index) {
        <ion-item lines="none">
          <ion-label>{{ document.name }}</ion-label>
          <ion-button color="danger"
            (click)="removeDocument(document)">
            <ion-icon slot="icon-only"
              name="trash-bin-outline"></ion-icon>
          </ion-button>
        </ion-item>
      }
      <ion-button color="white"
        shape="round">
        <form method="post"
          enctype="multipart/form-data"
          class="input-form">
          <label class="input-label"
            for="file">
            <input id="file"
              type="file"
              multiple="true"
              name="file"
              accept="application/pdf, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              (change)="selectFiles($event)" />
            {{ 'projects.addAttachment' | translate }}
          </label>
        </form>
      </ion-button>
      <div class="analyze">
        <ion-button color="white"
          [disabled]="contractUrls().length === 0"
          (click)="analyze()">{{ 'projects.next' | translate }}</ion-button>
      </div>
    } @else if (step() === 3) {
      <h4>{{ 'contract.loadingTitle' | translate }}</h4>
      <p>{{ 'contract.loadingInfo' | translate }}</p>
      <ion-item lines="none">
        {{ 'contract.loading1' | translate }}
        @if (loading1() && aiContract() == null) {
          <ion-spinner slot="end"></ion-spinner>
        } @else {
          <ion-icon slot="end"
            color="success"
            name="checkmark-circle-outline"></ion-icon>
        }
      </ion-item>
      <ion-item lines="none">
        {{ 'contract.loading2' | translate }}
        @if (loading2() && aiContract() == null) {
          <ion-spinner slot="end"></ion-spinner>
        } @else {
          <ion-icon slot="end"
            color="success"
            name="checkmark-circle-outline"></ion-icon>
        }
      </ion-item>
      <ion-item lines="none">
        {{ 'contract.loading3' | translate }}
        @if (aiContract() == null) {
          <ion-spinner slot="end"></ion-spinner>
        } @else {
          <ion-icon slot="end"
            color="success"
            name="checkmark-circle-outline"></ion-icon>
        }
      </ion-item>
      @if (aiContract()) {
        <div class="analyze">
          <h5>{{ 'projects.loadingReady' | translate }}</h5>
          <ion-button color="light"
            [disabled]="aiContract() == null"
            (click)="checkContract()">
            {{ 'projects.next' | translate }}
          </ion-button>
        </div>
      }
    } @else if (step() === 4) {
      <h3>{{ aiContract().name }}</h3>
      <h4>{{ 'contract.loading1' | translate }}</h4>
      <form [formGroup]="formGroup">
        <div class="info">
          <div>
            <ion-item lines="none">
              <app-select-day color="white"
                [id]="'contractStart'"
                [name]="'contract.start'"
                size="medium"
                [value]="formGroup.get('start').value"
                (changed)="onDateChange($event, 'start')"></app-select-day>
            </ion-item>
          </div>
          <div>
            <ion-item lines="none">
              <app-select-day color="white"
                [id]="'contractEnd'"
                [name]="'contract.end'"
                size="medium"
                [value]="formGroup.get('end').value"
                (changed)="onDateChange($event, 'end')"></app-select-day>
            </ion-item>
          </div>
          <div>
            <ion-item lines="none">
              <ion-input [label]="'contract.model' | translate"
                labelPlacement="stacked"
                formControlName="model"></ion-input>
            </ion-item>
          </div>
          <div>
            <ion-item lines="none">
              <ion-input [label]="'sites.new.client' | translate"
                labelPlacement="stacked"
                formControlName="client"></ion-input>
            </ion-item>
          </div>
          <div>
            <ion-item lines="none">
              <ion-input [label]="'timesheet.site' | translate"
                labelPlacement="stacked"
                formControlName="site"></ion-input>
            </ion-item>
          </div>
          <div>
            <ion-item lines="none">
              <ion-input [label]="'calendar.site.area' | translate"
                labelPlacement="stacked"
                formControlName="area"></ion-input>
            </ion-item>
          </div>
        </div>
      </form>
      <h4>{{ 'contract.tasks' | translate }}</h4>
      @for (task of tasks(); track $index) {
        <div class="info">
          <ion-item lines="none">
            <ion-label>{{ task.name }}</ion-label>
          </ion-item>
          <ion-item lines="none">
            {{ 'contract.repeats.' + task.repeat | translate }}
          </ion-item>
          <ion-item lines="none">
            <app-select-day [id]="'task_' + task.name"
              [color]="'white'"
              [value]="task.firstDate"
              [name]="'sites.workers.startDate'"
              (changed)="task.firstDate = $event"></app-select-day>
          </ion-item>
        </div>
      } @empty {
        <app-no-results></app-no-results>
      }
      <h4>{{ 'contract.notes' | translate }}</h4>
      @for (task of continousTasks(); track $index) {
        <div class="info">
          <ion-item lines="none">
            <ion-label>{{ task.name }}</ion-label>
          </ion-item>
          <ion-item lines="none">
            {{ 'contract.repeats.' + task.repeat | translate }}
          </ion-item>
          <ion-item lines="none">
            {{ task.pricing }}
          </ion-item>
        </div>
      } @empty {
        <app-no-results></app-no-results>
      }
      <h4>{{ 'contract.additionalWork' | translate }}</h4>
      @for (task of additionalTasks(); track $index) {
        <div class="info">
          <ion-item lines="none">
            <ion-label>{{ task.name }}</ion-label>
          </ion-item>
          <ion-item lines="none">
            {{ 'contract.repeats.' + task.repeat | translate }}
          </ion-item>
          <ion-item lines="none">
            {{ task.pricing }}
          </ion-item>
        </div>
      } @empty {
        <app-no-results></app-no-results>
      }
      <div class="ion-margin-top contacts">
        <h4>{{ 'projects.clientContracts' | translate }}</h4>
        @for (contact of aiContract().clientContacts; track $index) {
          <ion-item lines="none"
            color="primary">
            <div class="flex tw:flex">
              <ion-input [(ngModel)]="contact.name"
                [ngModelOptions]="{standalone: true}">
              </ion-input>
              <ion-input [(ngModel)]="contact.email"
                [ngModelOptions]="{standalone: true}">
              </ion-input>
              <ion-input [(ngModel)]="contact.phone"
                [ngModelOptions]="{standalone: true}">
              </ion-input>
            </div>
          </ion-item>
        } @empty {
          <app-no-results></app-no-results>
        }
      </div>
      <div>
        <ion-button color="white"
          (click)="addContact()">
          {{ 'sites.new.addContact' | translate }}
        </ion-button>
      </div>
      <div class="analyze">
        <ion-button color="light"
          (click)="save()">
          <app-loading-button [loading]="loading()">
            {{ 'general.save' | translate }}
          </app-loading-button>
        </ion-button>
      </div>
    } @else if (step() === 5) {
      <h4>{{ 'contract.created' | translate:{ name: aiContract().name } }}</h4>
      <p>{{ 'contract.createdInfo' | translate }}</p>
      <div class="analyze">
        <ion-button color="light"
          [disabled]="contract() == null"
          (click)="close()">
          <app-loading-button [loading]="loading()">
            {{ 'general.close' | translate }}
          </app-loading-button>
        </ion-button>
      </div>
    }
    <ng-container contentEnd>
      @if (step() > 1) {
        <ion-item lines="none"
          [class.phase-selected]="step() === 2">
          <span slot="start">1</span>
          <ion-label>{{ 'projects.phase1' | translate }}</ion-label>
        </ion-item>
        <ion-item lines="none"
          [class.phase-selected]="step() === 3">
          <span slot="start">2</span>
          <ion-label>{{ 'projects.phase2' | translate }}</ion-label>
        </ion-item>
        <ion-item lines="none"
          [class.phase-selected]="step() === 4">
          <span slot="start">3</span>
          <ion-label>{{ 'contract.phase3' | translate }}</ion-label>
        </ion-item>
        <ion-item lines="none"
          [class.phase-selected]="step() === 5">
          <span slot="start">4</span>
          <ion-label>{{ 'projects.phase4' | translate }}</ion-label>
        </ion-item>
      }
    </ng-container>
  </app-split-page>
</app-main-dialog>